export const PATHS = {
  home: "/",
  account: "/account",
  login: "/login",
  register: "/register",
  products: "/produkter",
  product: "/produkt",
  checkout: {
    index: "/checkout",
    summary: "/checkout/summary",
  },
  termsAndConditions: "/terms-and-conditions",
  privacyPolicy: "/privacy-policy",
};

export const AUTH_REQUIRED_PATHS = [PATHS.account];
